import React from 'react';
import PropTypes from 'prop-types';

const TrendUp01Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="15"
    height="9"
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.09998 7.70005L4.68398 4.25389L7.75597 7.20774L13.9 1.30005M13.9 1.30005H9.29198M13.9 1.30005V5.73082"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

TrendUp01Icon.propTypes = {
  color: PropTypes.string,
};

export default TrendUp01Icon;
